export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indietro"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si prega di fornire un nuovo nome per l'asset"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questo nome ti aiuterà a identificare più facilmente il portafoglio nella tua lista degli asset."])}
}